export class PlaceholderImages {
    public static VOCABULARY = require("./images/placeholders/vocabulary.png");
    public static VOCABULARY_TEXT_ONLY = require("./images/placeholders/vocabularyTextOnly.png");
    public static EXPRESSION = require("./images/placeholders/expression.png");
    public static EXPRESSION_TEXT_ONLY = require("./images/placeholders/expressionTextOnly.png");
}
